import { WidgetXcomponent } from '../../xcomponent/dist/widget-xcomponent-loader.min'
import { inAdminWidgetPage, widgetIdInPath, widgetUrl } from '../../utilities'

export default class XComponent {
  constructor(options) {
    this.options = options
  }

  render(onInit) {
    const {
            cartToken, onSubmit
          }         = this.options,
          div       = document.createElement('div'),
          form      = document.querySelector('form[action="/cart/add"]'),
          dom       = `<div>
                        <span class="bta-widget-close">&times;</span>
                        <div id="bta-widget-container"></div>
                      </div>`,
          extra     = {},
          widget_id = inAdminWidgetPage() ? widgetIdInPath() : null

    if (!form) return

    div.id = 'bta-product-widget'
    div.classList.add('bta-hide')
    div.innerHTML = dom
    form.parentNode.insertBefore(div, form)

    if (widget_id) extra.widget_id = widget_id

    const container  = document.querySelector('#bta-widget-container'),
          xComponent = WidgetXcomponent.init({
            onInit,
            onSubmit,
            cartToken,
            customUrl: widgetUrl(this.options, extra),
          }, 'iframe', container)

    xComponent.render(container)

    return {container, xComponent}
  }
}
